'use strict';

var wrapInList = require('./wrapInList');

/**
 * User pressed Tab in an editor
 */
function onTab(event, data, state, opts, list) {
    var startBlock = state.startBlock;
    var startOffset = state.startOffset;
    var isCollapsed = state.isCollapsed;


    if (!isCollapsed) {
        return;
    }

    // If pressing tab at the end of the block, we rap the item in a new list
    if (startOffset === startBlock.length) {
        event.preventDefault();

        return wrapInList(state.transform().splitBlock().apply(), list.type, opts);
    }
}

module.exports = onTab;


//////////////////
// WEBPACK FOOTER
// ./~/slate-edit-list/dist/onTab.js
// module id = 677
// module chunks = 0